import { SubjectManageActionTypes } from '../actions/subjectManagement.actions';
import { SubjectManageState } from '../initial.state';

function SubjectManageReducer(state = new SubjectManageState(), action) {
  switch (action.type) {
    case SubjectManageActionTypes.ATTACH_SUBTOPIC_VIDEO:
      return {
        ...state,
      };

    case SubjectManageActionTypes.ALL_SUBJECTS_SUCCESS:
      return {
        ...state,
        subjects: action.payload.data,
      };

    case SubjectManageActionTypes.GENERATE_SUBJECT_LIST:
      return {
        ...state,
        subjects: action.payload,
      };

    case SubjectManageActionTypes.ALL_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload.data,
      };

    // For now, i will add all the viewed subjects in both an array as individual property
    case SubjectManageActionTypes.SUBJECT_UNITS_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const { data } = action.payload;
      return {
        ...state,
        [data.subjectId]: data,
        subjectsWithUnits: [data], // [ ...state.subjectsWithUnits, data ],
        currentSubjectId: data.subjectId,
      };

    case SubjectManageActionTypes.BUILD_SUBJECT_UNIT_PAYLOAD:
      return {
        ...state,
        subjectsUnitPayload: [...state.subjectsUnitPayload, action.payload],
      };

    case SubjectManageActionTypes.GET_SUBJECT_VIDEOS:
      return {
        ...state,
        // subjectsVideos: [...state.subjectsVideos, action.payload.data],
        subjectsVideos: [action.payload.data],
      };

    case SubjectManageActionTypes.GET_SELECTED_VIDEO_URL:
      return {
        ...state,
        subjectVideoUrls: [
          ...state.subjectVideoUrls,
          { ...action.payload.metaData, responseData: action.payload.response.data },
        ],
      };

    case SubjectManageActionTypes.GET_SUBJECT_ASSIGNEES:
      return {
        ...state,
        assignees: action.payload.data.contentDevelopers,
      };

    default:
      return {
        ...state,
      };
  }
}

export { SubjectManageReducer };
